import React from 'react';

const Step4_Complete = ({ summary, onRestart, clid }) => {
  const createdCount = summary?.created_count || 0;
  const targetClid = summary?.clid || clid || '';
  const steps = ['Step 1', 'Step 2', 'Step 3', 'Complete'];

  const handleViewClinic = () => {
    if (!targetClid) return;
    window.location.href = `/clinics/${targetClid}#qaknowledgebase`;
  };

  if (!summary?.success) {
    return (
      <div className="text-center space-y-6">
        <h2 className="text-2xl font-bold text-gray-900">Step 4: Complete</h2>
        <p className="text-gray-600">
          No import summary found. Please restart the flow to import new Q&A items.
        </p>
        <button
          type="button"
          onClick={onRestart}
          className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          Start New Import
        </button>
      </div>
    );
  }

  return (
    <div className="space-y-8 text-center">
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Step 4: Complete</h2>
        <p className="text-gray-600">Your Q&A items have been imported successfully.</p>
      </div>

      <div className="flex flex-wrap items-center justify-center gap-4 mb-2">
        {steps.map((label, index) => (
          <div key={label} className="flex items-center gap-3">
            <div
              className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold ${
                index === steps.length - 1 ? 'bg-green-600 text-white' : 'bg-green-500 text-white'
              }`}
            >
              {index === steps.length - 1 ? '✓' : index + 1}
            </div>
            <span
              className={`text-sm font-medium ${
                index === steps.length - 1 ? 'text-green-700' : 'text-green-800'
              }`}
            >
              {label}
            </span>
            {index < steps.length - 1 && <div className="hidden sm:block w-12 h-0.5 bg-green-200"></div>}
          </div>
        ))}
      </div>

      <div className="bg-green-50 border border-green-200 rounded-lg p-6">
        <p className="font-semibold text-green-800 text-lg">✓ Import Completed</p>
        <p className="text-green-900 mt-2">
          Successfully imported <span className="font-bold">{createdCount}</span> QA item
          {createdCount === 1 ? '' : 's'}.
        </p>
        {targetClid && (
          <p className="text-sm text-green-800 mt-2">
            Updated clinic ID: <span className="font-mono text-green-900">{targetClid}</span>
          </p>
        )}
      </div>

      <div className="flex flex-wrap justify-center gap-4">
        <button
          type="button"
          onClick={onRestart}
          className="px-8 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          Start New Import
        </button>
        {targetClid && (
          <button
            type="button"
            onClick={handleViewClinic}
            className="px-8 py-3 bg-green-600 text-white rounded-md hover:bg-green-700"
          >
            View Clinic QA
          </button>
        )}
      </div>
    </div>
  );
};

export default Step4_Complete;

